<div class="ui-tab w-100 h-100 flex-col gap-16">
  <ng-template #connectedGraphCell
               let-row="row">
    @if (row.target?.graphId) {
      <div class="active-link c-p"
           (click)="goToGraph(row.target.graphId)">
        {{ selectWorkflowsEntitiesSig()[row.target.graphId]?.preview?.name || '-' }}
      </div>
    } @else {
      <div></div>
    }
  </ng-template>

  <div class="flex-row space-between-center"
       [class.end-center]="!selectWebhooksSig()?.length">
    @if (selectWebhooksSig()?.length) {
      <ui-search style="width: 320px"
                 [searchQuery]="search()"
                 (onInput)="search.set($event)"
                 [placeholder]="'WORKFLOW_WEBHOOK.PLACEHOLDERS.SEARCH'|translate"></ui-search>
    }
    <ui-button [text]="'COMMON.CREATE'|translate"
               (click)="create()">
    </ui-button>
  </div>

  <div class="h-100 min-h-0">
    <div class="h-100 min-h-0 flex-col">
      <div class="h-100 min-h-0">
        @if(selectIsLoadingSig()) {
          <ui-preloader [color]="loaderColor.blue"
                        style="padding: 100px 0;">
          </ui-preloader>
        } @else {
          @switch (viewState()) {
            @case (viewStates.HAS_CONTENT) {
              <ui-dataset-table
                [data]="filteredWebhooksSig()"
                [config]="tableConfig()"
                (rowAction)="onRowAction($event)">
              </ui-dataset-table>
            }
            @case (viewStates.NO_RESULTS) {
              <ui-no-data [imgSrc]="noResults.imgSrc"
                          [title]="noResults.title|translate">
              </ui-no-data>
            }
            @case (viewStates.INITIAL_EMPTY) {
              <ui-no-data [imgSrc]="noData.imgSrc"
                          [title]="noData.title|translate">
              </ui-no-data>
            }
          }
        }
      </div>
    </div>
  </div>
</div>